import { participantTypes, teamTypes, generalTypes } from '../actions'

const participants = (state = [], action) => {
  switch (action.type) {
    case generalTypes.GET_INIT_DATA:
      return []
    case participantTypes.SAVE:
      return action.participants
    case participantTypes.UPDATE:
      let newParticipants = state.slice(0)
      const index = newParticipants.findIndex(p => p.id === action.participant.id)
      index > -1 && (newParticipants[index] = action.participant)
      index === -1 && newParticipants.push(action.participant)
      return [...newParticipants]
    case participantTypes.REMOVE:
      return state.slice(0).filter(p => p.id !== action.id)
    case teamTypes.REMOVE:
      return state.slice(0).filter(p => p.team !== action.id)
    default: return state
  }
}

export default participants



// WEBPACK FOOTER //
// ./src/reducers/participants.js